export const orderCompletedAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }